import { render, staticRenderFns } from "./GuestInactive.vue?vue&type=template&id=2b8dc880&scoped=true&"
import script from "./GuestInactive.vue?vue&type=script&lang=js&"
export * from "./GuestInactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8dc880",
  null
  
)

export default component.exports